import * as React from 'react';

import ProgressTracker from 'bundles/skills-common/private/progress-tracker/ProgressTracker';

const SvgStartingScore = ({ hideTarget }: { hideTarget?: boolean }) => (
  <div style={{ width: 320 }}>
    <ProgressTracker
      segments={[50, 150, 350]}
      hideTarget={hideTarget}
      target={hideTarget ? undefined : 180}
      maxScore={500}
    />
  </div>
);

export default SvgStartingScore;
